export class ComparableItem {
  constructor(
    public materialNumber: string,
    public plant: string,
    public calculationId: string
  ) {}
}
